import styled from "styled-components/macro";
import { themePalette } from "../../theme";

export const MissingInfoTable = styled.div`
  display: grid;
  grid-auto-rows: auto;
  border: 1px solid ${themePalette.neutral200};
  border-radius: 6px;
  overflow: hidden;
`;

export const MissingInfoRow = styled.div<{ $header?: boolean }>`
  display: grid;
  align-items: center;
  grid-template-columns: 40% 60%;
  border-top: ${({ $header }) => ($header ? "none" : "1px solid #dbdee6")};
  padding-left: 10px;
  cursor: ${({ $header }) => ($header ? "default" : "pointer")};

  &:hover {
    background-color: ${({ $header, theme }) =>
      $header ? "transparent" : theme.rowMissingInfoRed};
  }
`;

export const HeaderCell = styled.div`
  display: flex;
  align-items: center;
  text-transform: uppercase;
  color: ${themePalette.neutral400};
  font-weight: 800;
  font-size: 14px;
  height: 40px;
`;

export const PatientCell = styled.div`
  display: flex;
  align-items: center;
  text-transform: uppercase;
  color: ${themePalette.redDark};
  font-weight: 800;
  padding-left: 10px;
  font-size: 14px;
  min-height: 40px;
`;

export const StatusBadges = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 5px 0;
`;

export const StatusBadge = styled.div`
  height: 28px;
  font-weight: 400;
  font-size: 14px;
  align-items: center;
  display: inline-flex;
  padding: 2px 10px;
  margin: 5px 5px 5px 0;
  justify-content: center;
  line-height: 20px;
  color: ${themePalette.neutral700};
  background: ${themePalette.neutral50};
  border: 1px solid ${themePalette.neutral100};
  border-radius: 6px;
`;
